import { SlingoEvent, TestEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
import { GameEvent } from "../../../controller/event/GameEvent";
/**
 * Game-specific background implementation which responsively scales to the whole screen size rather than just the game size.
 */
export class GameBackground extends AbstractGameView {
    create() {
        super.create();
        this.backgroundSpine = TitanSpine.createSpine(this, "background", this.landscapeProperties.backgroundProperties, this.portraitProperties?.backgroundProperties);
        this.borderSprite = TitanSprite.createSprite(this, "border", this.landscapeProperties.borderProperties, this.portraitProperties?.borderProperties);
    }
    postCreate() {
        super.postCreate();
        SpineUtil.playLoop(this.backgroundSpine, "idle", 0);
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(SlingoEvent.SLINGO_WIN_ANIMATION, this.handleSlingoWinAnimation);
        this.registerGame(TestEvent.SLINGO_1, this.handleSlingoWinAnimation);
        this.registerGame(TestEvent.SLINGO_2, this.handleSlingoWinAnimation);
        this.registerGame(TestEvent.SLINGO_3, this.handleSlingoWinAnimation);
        this.registerGame(TestEvent.SLINGO_4, this.handleSlingoWinAnimation);
        this.registerGame(GameEvent.WIN_LINE_FIREWORKS_COMPLETE, this.handleSlingoWinAnimation);
    }
    handleSlingoWinAnimation() {
        SpineUtil.play(this.backgroundSpine, "reaction", null, null, 1);
    }
}
//# sourceMappingURL=GameBackground.js.map